import { CertificationStepCard } from '@/components/Cards';
import { cn } from '@/utils';
import { COMMON_TEXT } from '@/constants';
import { ISimulationPlanningCard } from '@/types';
import { SkeletonLoader } from '@/components/Loaders/SkeletonLoader';
import { TextContent } from '@/components/Text';

interface Props {
  className?: string;
  isLoading?: boolean;
  onCardActionClick?: (card: ISimulationPlanningCard) => void;
  planningCards?: ISimulationPlanningCard[];
}

export const SimulationScenarioPlanningCards: React.FC<Props> = ({
  className,
  isLoading,
  onCardActionClick,
  planningCards = [],
}) => {
  return (
    <section
      className={cn('w-full max-w-7xl space-y-4', className)}
      data-testid="simulation-planning-cards-section"
    >
      <TextContent
        className="!font-display"
        isLoading={isLoading}
        label={COMMON_TEXT.PRECALL_PLANNING}
        level={2}
        loadingClassName="w-1/3 h-[1.75rem]"
        loadingLines={1}
        testId="simulation-planning-cards-section-title"
        type="headline"
        variant="bodyLarge"
      />
      <ol
        className={cn(
          'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
          'font-text text-body-large leading-body-large gap-6',
          'text-semantic-text-secondary',
        )}
      >
        {isLoading ? (
          <>
            {[1, 2, 3, 4].map((n) => (
              <li key={n}>
                <SkeletonLoader height="3xl" width="full" rounded="md" />
              </li>
            ))}
          </>
        ) : (
          <>
            {planningCards.map((objective, index) => (
              <li key={index}>
                <CertificationStepCard
                  title={objective.title}
                  stepLabel={'Step ' + objective.stepNumber.toString()}
                  actionLabel={objective.actionLabel}
                  iconName={objective.iconName}
                  onAction={() => onCardActionClick?.(objective)}
                />
              </li>
            ))}
          </>
        )}
      </ol>
    </section>
  );
};
